import { DetailsTabMenu } from '@/components/details';
import { participantRoute } from '@/features/dashboard/participants/routes/participantRoute.ts';
import { participantTabLinks } from '@/features/dashboard/bookingChanges/routes/detailsTabs.ts';

/** Goły adres uczestnika: menu kafli na telefonie, „Informacje” szeroko. */
const ParticipantTabMenu = () => {
  const { participantId } = participantRoute.useParams();
  const search = participantRoute.useSearch();

  return <DetailsTabMenu tabs={participantTabLinks(participantId, search)} />;
};

export default ParticipantTabMenu;
